import Keycloak from 'keycloak-js'

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8080',
  realm: import.meta.env.VITE_KEYCLOAK_REALM || 'sphere',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'sphere-frontend',
})

// après const keycloak = new Keycloak(config)
if (typeof window !== 'undefined') (window as any).keycloak = keycloak
export default keycloak
